import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ApiKey } from 'Interfaces/ApiKey';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ApiKey['id']) =>
    $actions.apiKey.revokeApiKey(dispatch, payload),
  );
};
